<!-- bogie shim -->
<div class="column-container__column">
    <div class="bogie-shim-count"
        style="border: 1px solid #e0e0e0; border-radius: 6px; padding: 12px; background-color: #fafafa; min-width: 180px;">
        <div class="bogie-title" style="font-size: 13px; color: #828282; font-weight: 400; margin-bottom: 8px;">
            {{ 'Bogie Shim Count' | translate | async }}
        </div>
        <div class="major-bogie-section" *ngIf="side == 1" style="position: relative;">
            <div class="history-icon" (click)="viewHistory(side)" *ngIf="showHistory">
                <span class="material-icons" [matTooltip]="'Bogie History'">
                    history
                </span>
            </div>
            <div>
                <div class="bogie-row" *ngFor="let bogie of bogieShimLeft">
                    <div class="parent-div">
                        <div class="parent-div">
                            <span class="bogie-name">{{ bogie.MajorBogie?.BogieName }}:</span>
                            <span *ngIf="isViewMode" class="bogie-count">{{ bogie.ShimCount }}</span>
                            <input type="number" [(ngModel)]="bogie.ShimCount" class="bogie-shim-input" min="0"
                                (keypress)="ValidateNumberInputs($event)" *ngIf="!isViewMode"
                                (ngModelChange)="onShimCountChange(bogie)" max="99" maxlength="2"
                                oninput="if(this.value.length > 2) this.value = this.value.slice(0, 2)">
                        </div>
                        <div class="parent-div">
                            <div (click)="addComment(bogie)" style="margin-right: 10px;"
                                [ngClass]="bogie.Comment ? 'has-comment' : 'add-recommendation'"
                                [matTooltip]="bogie.Comment || ''"
                                title="{{ !bogie.Comment ? ('Add Comment' | translate | async) : '' }}">
                                <i class="material-icons observation-image__icon">
                                    message
                                </i>
                            </div>
                            <div class="inspection-component-photo" style="margin-left: 10px;">
                                <div class="photo-container" style="display: flex;">
                                    <label class="upload-container" *ngIf="!isViewMode"
                                        title="{{'Add photo' | translate | async}}">
                                        <i class="material-icons upload-container__icon">
                                            add_a_photo
                                        </i>
                                        <input style="display: none;" type="file" accept="image/*"
                                            (change)="onSelectPhoto($event, bogie)">
                                    </label>
                                    <div style="display: flex;gap: 5px;"
                                        *ngIf="imageUploaded || isInterp || inspId > 0">
                                        <div *ngFor="let i of bogie.Images">
                                            <img class="observation-image__photo" [src]="i.ImageUrl"
                                                (click)="ViewInspectionImage(i.ImageUrl, i.ImageId)" />
                                        </div>
                                    </div>
                                    <div style="display: flex;gap: 5px;" *ngIf="isViewMode">
                                        <div *ngFor="let img of bogie.Images">
                                            <img class="observation-image__photo" [src]="img.ImageUrl"
                                                (click)="ViewInspectionImage(img.ImageUrl, img.ImageId)" />
                                        </div>
                                    </div>
                                    <mat-spinner diameter="24" *ngIf="bogie.photoLoading && !isViewMode"></mat-spinner>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="major-bogie-section" *ngIf="side == 2" style="position: relative;">
            <div class="history-icon" (click)="viewHistory(side)" *ngIf="showHistory">
                <span class="material-icons" [matTooltip]="'Bogie History'">
                    history
                </span>
            </div>
            <div class="bogie-row" *ngFor="let bogie of bogieShimRight || []; let i = index">
                <div class="parent-div">
                    <div class="parent-div">
                        <span class="bogie-name">{{ bogie.MajorBogie?.BogieName }}:</span>
                        <span *ngIf="isViewMode" class="bogie-count">{{ bogie.ShimCount }}</span>
                        <input type="number" [(ngModel)]="bogie.ShimCount" class="bogie-shim-input" min="0"
                            (keypress)="ValidateNumberInputs($event)" *ngIf="!isViewMode"
                            (ngModelChange)="onShimCountChange(bogie)" max="99" maxlength="2"
                            oninput="if(this.value.length > 2) this.value = this.value.slice(0, 2)">
                    </div>
                    <div class="parent-div">
                        <div (click)="addComment(bogie)" style="margin-right: 10px;"
                            [ngClass]="bogie.Comment ? 'has-comment' : 'add-recommendation'"
                            [matTooltip]="bogie.Comment || ''"
                            title="{{ !bogie.Comment ? ('Add Comment' | translate | async) : '' }}">
                            <i class="material-icons observation-image__icon">
                                message
                            </i>
                        </div>
                        <div class="inspection-component-photo" style="margin-left: 10px;">
                            <div class="photo-container" style="display: flex;">
                                <label class="upload-container" *ngIf="!isViewMode"
                                    title="{{'Add photo' | translate | async}}">
                                    <i class="material-icons upload-container__icon">
                                        add_a_photo
                                    </i>
                                    <input style="display: none;" type="file" accept="image/*"
                                        (change)="onSelectPhoto($event, bogie)">
                                </label>
                                <div style="display: flex;gap: 5px;" *ngIf="imageUploaded || isInterp|| inspId > 0">
                                    <div *ngFor="let i of bogie.Images">
                                        <img class="observation-image__photo" [src]="i.ImageUrl"
                                            (click)="ViewInspectionImage(i.ImageUrl, i.ImageId)" />
                                    </div>
                                </div>
                                <div style="display: flex;gap: 5px;" *ngIf="isViewMode">
                                    <div *ngFor="let img of bogie.Images">
                                        <img class="observation-image__photo" [src]="img.ImageUrl"
                                            (click)="ViewInspectionImage(img.ImageUrl, img.ImageId)" />
                                    </div>
                                </div>
                                <mat-spinner diameter="24" *ngIf="bogie.photoLoading && !isViewMode"></mat-spinner>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>